import React, { useCallback, useEffect, useState } from "react";

import "./Slider.scss";

export const Slider = ({
  className = "",
  title = "Title",
  selected = 0,
  amountFormatter = (d) => d.toFixed(0),
  min = 0,
  max = 1,
  step = "any",
  width = 200,
  valueWidth = `80px`,
  descriptor = "",
  hideAmountLabel = false,
  onChange = () => {},
}) => {
  const [value, setValue] = useState(selected);

  useEffect(() => {
    setValue(selected);
  }, [selected]);

  const onValueChange = useCallback(
    (e) => {
      setValue(+e.target.value);
      onChange(e.target.value);
    },
    [setValue, onChange]
  );

  return (
    <div
      className={`slider__container flex flex-column items-center ${className}`}
    >
      <div className="flex flex-row">
        <div className="flex flex-column items-center">
          <input
            style={{ width: `${width}px` }}
            className=""
            type="range"
            name={title}
            step={step}
            value={value}
            min={min}
            max={max}
            onChange={onValueChange}
          />
          <label className="block-font h6 mt1 uppercase" htmlFor={title}>
            {title}
          </label>
        </div>
        {!hideAmountLabel && (
          <div className="flex flex-column items-start">
            <div
              style={{
                width: valueWidth,
              }}
              className="ml1 block-font h5 self-center left-align"
            >
              {amountFormatter(value)}
              {` ${descriptor}`}
            </div>
          </div>
        )}
      </div>
      {/* <div className="">
        <label className="block-font h6 uppercase" htmlFor={title}>
          {title}
        </label>
      </div> */}
    </div>
  );
};
